'use strict';

export default class PositionTypeViewCtrl {
  constructor($stateParams, $state, PositionTypeSvc, GroupAuthSvc, LoaderSvc) {
    var that = this;
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // current group
    this.ptId = $stateParams.ptId; // current group

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'positionType', 'R');

    if(!this.ptId) {
      return $state.go('group.view.settings.positionType.list');
    }
    //load positionType
    function loadPositionType() {
      LoaderSvc.start();
      PositionTypeSvc.get({groupId: that.groupId, id: that.ptId}).$promise
        .then(function(positionType) {
          that.positionType = positionType;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Position Type');
        });
    }
    loadPositionType();
  }
}

PositionTypeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'PositionTypeSvc',
  'GroupAuthSvc',
  'LoaderSvc'
];
